<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import KPIItemForm from "../../../components/performance/kpiitem/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": KPIItemForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('pmkpiitem.createnewkpiitem'),
      pageTitleValue: "",
      formData: {
        pmkpitypeid: 1, // default is Individual, 2 = Common KPI 
        description: null,
        goal: null,
        kpi: null,
        pmtargetoptionid: null,
        targetType: null, 
        pmcalmethodid: null,
        threshold: null,
        target: null,
        stretch: null,
        subperiodcount: 1,
        weightage: null,
        pmkpifinalscorecalmethodid: null,
        pmkpicatid: null,
        pmkpicatcode: null, 
        pmratesetid: null,
        pmratesetdesc: null,
        basedonpercentage: true,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
      },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/kpiitem/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "kpiitemlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
           console.log("err", err);
        });
    },

  

    cancelHandler() {
      this.$router.push({ name: "kpiitemlist" });
    },
  },
};
</script>